import React, {Component} from 'react';
import BasicLayout from "../../views/MainLayout";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import {
    getCurrentUser,
    userAddressUpdate,
    userEventsUpdate,
    userFormEdit, userSocialUpdate,
    userSurveyUpdate,
    userUpdate,
} from "../../redux-actions/auth";
import {message} from "antd";
import qs from 'query-string'
import UserView from "../../fragments/UserView/UserView";

class ProfilePage extends Component {

    state = {
        orcidRegistration: false
    }

    componentDidMount() {
        this.props.getCurrentUser();
        const isFromOrcid = qs.parse(this.props.location.search)['orcid']
        this.setState({
            orcidRegistration: isFromOrcid
        })
        this.props.history.push('/profile')

    }


    handleSubmit = (e) => {
        e.preventDefault();
        if(this.props.action) {
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    this.props.action(values).then((response) => message.info("User information has been updated."))
                }
            });
        }
    }

    render() {
        const {user, userUpdate, userAddressUpdate, userSurveyUpdate, userSocialUpdate} = this.props;

        return (
            <BasicLayout>
                <UserView
                    orcidRegistration={this.state.orcidRegistration}
                    user={user}
                    allowEdit={true}
                    userCredentialsUpdate={userUpdate}
                    userAddressUpdate={userAddressUpdate}
                    userSurveyUpdate={userSurveyUpdate}
                    userSocialUpdate={userSocialUpdate}
                    showActions={false}
                      />
            </BasicLayout>
        )
    }
}


const mapStateToProps = (state, ownProps) => ({
    user: state.auth.user,
    formContent : state.auth.userForm
})

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getCurrentUser,
        userUpdate,
        userSurveyUpdate,
        userAddressUpdate,
        userEventsUpdate,
        userSocialUpdate,
        userFormEdit,
    },
    dispatch,
)

ProfilePage = connect(mapStateToProps, mapDispatchToProps)(ProfilePage)
export default ProfilePage

